import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  showFilterMenu,
  hideFilterMenu,
} from "../../features/slices/FilterSlice";
import { setGameFilters } from "../../features/slices/GamesSlice";

function FilterSection({ title, items, selected, onToggle }) {
  const [open, setOpen] = useState(true);
  return (
    <div className="filter-section">
      <button
        type="button"
        className="filter-section-header"
        onClick={() => setOpen(!open)}
      >
        <span>{title}</span>
        <i className={`bi bi-chevron-down ${open ? "rotated" : ""}`}></i>
      </button>
      <div className={`filter-section-body ${open ? "open" : ""}`}>
        {items.map((item) => (
          <label className="filter-item" key={item.id}>
            <input
              type="checkbox"
              className="form-check-input mt-0 bg-black border border-light border-opacity-25"
              checked={selected.includes(item.id)}
              onChange={() => onToggle(item.id)}
            />
            <span className="mx-3">{item.name}</span>
          </label>
        ))}
      </div>
    </div>
  );
}

export default function FilterSidebar() {
  const dispatch = useDispatch();
  const { categories, providers, gameFilters } = useSelector(
    (state) => state.game
  );
  const isOpen = useSelector((state) => state.filter.isFilterMenuVisible);
  const [reachedGames, setReachedGames] = useState(false);
  const activeCount =
    gameFilters.categories.length + gameFilters.providers.length;

  // show the toggle only once the games section is scrolled into view,
  // not while the user is still on the banner
  useEffect(() => {
    const onScroll = () => {
      const gamesDiv = document.getElementById("gamesDiv");
      if (!gamesDiv) return;
      setReachedGames(
        gamesDiv.getBoundingClientRect().top <= window.innerHeight * 0.6
      );
    };
    onScroll();
    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  const toggle = (type, id) => {
    const list = gameFilters[type];
    const next = list.includes(id)
      ? list.filter((item) => item !== id)
      : [...list, id];
    dispatch(setGameFilters({ [type]: next }));
  };
  const clearAll = () =>
    dispatch(setGameFilters({ categories: [], providers: [] }));

  return (
    <>
      <button
        type="button"
        className={`filter-toggle-btn ${
          isOpen || !reachedGames ? "hidden" : ""
        }`}
        onClick={() => dispatch(showFilterMenu())}
      >
        <i className="bi bi-funnel-fill"></i>
        <span className="filter-label">FILTERS</span>
        {activeCount > 0 && <span className="filter-count">{activeCount}</span>}
      </button>
      <div
        className={`filter-backdrop ${isOpen ? "show" : ""}`}
        onClick={() => dispatch(hideFilterMenu())}
      ></div>
      <aside className={`filter-sidebar ${isOpen ? "open" : ""}`}>
        <div className="filter-sidebar-inner">
          <div className="filter-sidebar-header">
            <span role="button" onClick={() => dispatch(hideFilterMenu())}>
              <i className="bi bi-x-lg"></i>
              <b className="mx-2">FILTERS</b>
            </span>
            {activeCount > 0 && (
              <span className="filter-clear" role="button" onClick={clearAll}>
                Clear
              </span>
            )}
          </div>
          <FilterSection
            title="Categories"
            items={categories}
            selected={gameFilters.categories}
            onToggle={(id) => toggle("categories", id)}
          />
          <FilterSection
            title="Providers"
            items={providers}
            selected={gameFilters.providers}
            onToggle={(id) => toggle("providers", id)}
          />
        </div>
      </aside>
    </>
  );
}
